import { Extension } from '@tiptap/core';
import { v4 } from 'uuid';

const NodeInfo = Extension.create({
  name: "nodeInfo",
  addOptions() {
    return {
      types: []
    };
  },
  // this adds:
  // - data-uuid v4 to all nodes
  // - data-created-at iso string
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          "data-uuid": {
            default: null,
            isRequired: true,
            keepOnSplit: false
          },
          "data-created-at": {
            default: null,
            isRequired: true,
            keepOnSplit: false
          }
        }
      }
    ];
  },
  onTransaction({ transaction }) {
    if (!transaction.docChanged) return;
    const types = this.options.types;
    const changes = [];
    transaction.doc.descendants((node, pos) => {
      if (types.includes(node.type.name) && this.options && !node.attrs["data-uuid"]) {
        changes.push(pos);
      }
    });
    if (changes.length) {
      const view = this.editor.view;
      const { state } = view;
      const newTransaction = state.tr;
      changes.forEach((pos) => {
        newTransaction.setMeta("$nodeInfo", true);
        newTransaction.setNodeAttribute(pos, "data-uuid", v4());
        newTransaction.setNodeAttribute(pos, "data-created-at", (/* @__PURE__ */ new Date()).toISOString());
      });
      view.dispatch(newTransaction);
    }
  },
  onCreate() {
    const types = this.options.types;
    const view = this.editor.view;
    const uuids = [];
    if (!view || !this.editor.isEditable) return;
    const { state } = view;
    let transaction = state.tr;
    let hasChanges = false;
    state.doc.descendants((node, pos) => {
      if (types.includes(node.type.name) && node.attrs["data-uuid"]) {
        const uuid = node.attrs["data-uuid"];
        if (uuids.includes(uuid)) {
          hasChanges = true;
          transaction = transaction.setNodeMarkup(pos, void 0, {
            ...node.attrs,
            "data-uuid": v4()
          });
        } else {
          uuids.push(uuid);
        }
      }
    });
    if (hasChanges) {
      transaction.setMeta("$nodeInfo", true);
      view.dispatch(transaction);
    }
  }
});

export { NodeInfo as default };
//# sourceMappingURL=NodeInfo.js.map
